import {Directive,HostListener} from '@angular/core'

@Directive({
	selector: '[numberMask]'
})
export class MyNumberDirective {

	@HostListener('input', ['$event'])
	onKeyDown(event: KeyboardEvent) {
		const input = event.target as HTMLInputElement;

		// remove spaces
		let trimmed = input.value.replace(/\s+/g, '');

		trimmed = trimmed.replace(/[^\d]/g, "");

		input.value = trimmed;

	}
}